import * as React from 'react';
import { colors } from '../features/employees/styles/personalakteStyles';

export interface ActiveFilter {
  key: string;
  label: string;
  onClear: () => void;
}

interface ActiveFiltersBarProps {
  filters: ActiveFilter[];
  onClearAll: () => void;
}

export default function ActiveFiltersBar({
  filters,
  onClearAll,
}: ActiveFiltersBarProps): React.JSX.Element | null {
  if (filters.length === 0) return null;

  const pillStyle: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    padding: '4px 10px',
    borderRadius: 9999,
    fontSize: 11,
    fontWeight: 600,
    background: `${colors.slate}14`,
    color: colors.slate,
    border: `1px solid ${colors.slate}30`,
    whiteSpace: 'nowrap',
  };

  const clearBtnStyle: React.CSSProperties = {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: 13,
    fontWeight: 700,
    color: colors.slate,
    padding: 0,
    lineHeight: 1,
    marginLeft: 2,
    opacity: 0.6,
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '6px 12px',
        marginBottom: 8,
        background: 'rgba(255, 255, 255, 0.9)',
        border: `1px solid ${colors.border}`,
        borderRadius: 10,
        flexWrap: 'wrap',
      }}
    >
      <span style={{ fontSize: 10, fontWeight: 700, color: colors.textMuted, textTransform: 'uppercase', letterSpacing: '0.3px' }}>
        {filters.length} {filters.length === 1 ? 'filter' : 'filters'}
      </span>

      {filters.map(f => (
        <span key={f.key} style={pillStyle}>
          {f.label}
          <button
            onClick={f.onClear}
            style={clearBtnStyle}
            aria-label={`Clear ${f.label}`}
            title={`Clear ${f.label}`}
          >
            ×
          </button>
        </span>
      ))}

      <button
        onClick={onClearAll}
        style={{
          marginLeft: 'auto',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: 10,
          fontWeight: 600,
          color: colors.textMuted,
          padding: '2px 6px',
          borderRadius: 6,
          transition: 'color 0.15s',
        }}
      >
        Clear all
      </button>
    </div>
  );
}
